// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type InvoiceDataFragment = { __typename?: 'InvoiceDataDTO', eInvoiceSendTimestamp: LocalDateTime | null, eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, bolloAmount: number | null, cashRegisterClosure: string | null, cashRegisterCode: string | null, cashRegisterNumber: string | null, cashRegisterPrintTimestamp: LocalDateTime | null, cigCode: string | null, codiceCommessaConvenzione: string | null, cupCode: string | null, dataDocumento: LocalDate | null, externalCode: string | null, id: number, idDocumento: string | null, invoiceId: number, relatedDocumentType: Types.RelatedDocumentTypeDto | null, vatChargeability: string | null };

export const InvoiceDataFragment = gql`
    fragment InvoiceData on InvoiceDataDTO {
  eInvoiceSendTimestamp
  eInvoiceStatus
  bolloAmount
  cashRegisterClosure
  cashRegisterCode
  cashRegisterNumber
  cashRegisterPrintTimestamp
  cigCode
  codiceCommessaConvenzione
  cupCode
  dataDocumento
  externalCode
  id
  idDocumento
  invoiceId
  relatedDocumentType
  vatChargeability
}
    `;
/* eslint-enable */